import { type GalleryCarouselItem } from '@lib/gallery'

import GalleryCarouselSlide3dPreview from './slide-3d-preview'
import GalleryCarouselSlideImage from './slide-image'

interface GalleryCarouselSlideProps {
  index: number
  item: GalleryCarouselItem
  preload?: boolean
  onClick?: (index: number) => void
}

const GalleryCarouselSlide = ({
  index,
  item,
  preload,
  onClick,
}: GalleryCarouselSlideProps) => {
  switch (item.type) {
    case 'image': {
      return (
        <GalleryCarouselSlideImage
          index={index}
          item={item}
          preload={preload}
          onClick={onClick}
        />
      )
    }

    case '3d-preview': {
      return (
        <GalleryCarouselSlide3dPreview
          index={index}
          item={item}
          onClick={onClick}
        />
      )
    }

    default: {
      return null
    }
  }
}

export default GalleryCarouselSlide
